module.exports = __webpack_public_path__ + "assets/img/me-icon.9529fa90.png";